import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

// Calcule le prochain intervalle de révision basé sur la qualité de la réponse
export const calculateNextReview = (card, quality) => {
  const easeFactor = card.easeFactor || 2.5;
  const interval = card.interval || 0;
  
  let newEaseFactor = easeFactor;
  let newInterval;

  if (quality >= 3) { // Réponse correcte
    if (interval === 0) newInterval = 1;
    else if (interval === 1) newInterval = 6;
    else newInterval = Math.round(interval * easeFactor);
    
    newEaseFactor = easeFactor + (0.1 - (5 - quality) * (0.08 + (5 - quality) * 0.02));
  } else { // Réponse incorrecte
    newInterval = 1;
    newEaseFactor = Math.max(1.3, easeFactor - 0.2);
  }

  newEaseFactor = Math.max(1.3, Math.min(2.5, newEaseFactor));
  
  return {
    nextReview: new Date(Date.now() + newInterval * 24 * 60 * 60 * 1000),
    easeFactor: newEaseFactor,
    interval: newInterval
  };
};

export const updateCardProgress = async (deckId, cardId, reviewData) => {
  const response = await axios.put(
    `${API_URL}/decks/${deckId}/cards/${cardId}/progress`,
    reviewData,
    { withCredentials: true }
  );
  return response.data;
}; 